import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
  methods: {
    async authenticateWithToken (token) {
      if (!token) {
        return Promise.reject(new Error('Token not provided'));
      }

      const authData = {
        access_token: token,
        token_type: 'Bearer',
        expires_in: 3600,
      };
      return this.$store.dispatch('user/loginUserWithAuthData', authData);
    },
  },
};
